import getCookie from "./getCookie"
import getTrackingId from "./getTrackingId"

const getTrackingCookies = () => {
  const tracking_id = getTrackingId()
  const fbc = getCookie("_fbc")
  const fbp = getCookie("_fbp")

  return {
    tracking_id,
    fbc,
    fbp,
  }
}

export default getTrackingCookies
